import React from 'react';
import PageWrapper from './style';
import PageTitle from '../../components/common/PageTitle';
import { connect } from 'react-redux';
import AdvertisementForm from '../../components/advertisement/AdvertisementForm';

const AdvertisementEdit = (props) => {
	return (
		<PageWrapper {...props}>
			<PageTitle title="sidebar.advertisement" className="plr-15" />
			<div className="user-tbl">
				<AdvertisementForm {...props} />
			</div>
		</PageWrapper>
	);
};

const mapStateToProps = (state) => {
	return {
		...state.themeChanger,
	};
};

export default connect(mapStateToProps, null)(AdvertisementEdit);
